import { useEffect, useRef } from "react";

const regs = new Set();
let active = null;

const named = (f, i) => new File([f], f.name && f.name !== "image.png" ? f.name
  : `pasted-${Date.now()}-${i}.${(f.type.split("/")[1] || "png").replace("jpeg", "jpg")}`, { type: f.type });

function onPaste(e) {
  if (e.defaultPrevented) return;
  const files = [...(e.clipboardData?.items || [])].filter((i) => i.kind === "file" && i.type.startsWith("image/")).map((i) => i.getAsFile()).filter(Boolean);
  if (!files.length) return;
  let list = [...regs].filter((r) => r.el.current?.isConnected && r.enabled.current);
  const inDialog = list.filter((r) => r.el.current.closest("[role=dialog]"));
  if (inDialog.length) list = inDialog;
  const target = list.find((r) => r.el.current.contains(e.target)) || (list.includes(active) ? active : null) || (list.length === 1 ? list[0] : null);
  if (!target) return;
  e.preventDefault();
  target.cb.current(files.map(named));
}

// Lets an uploader receive images pasted with Ctrl/Cmd+V; attach the returned ref to its container.
export function usePasteImages(onFiles, enabled = true) {
  const el = useRef(null), cb = useRef(onFiles), en = useRef(enabled);
  cb.current = onFiles;
  en.current = enabled;
  useEffect(() => {
    const r = { el, cb, enabled: en };
    if (!regs.size) window.addEventListener("paste", onPaste);
    regs.add(r);
    const node = el.current;
    const mark = () => { active = r; };
    node?.addEventListener("pointerenter", mark);
    node?.addEventListener("focusin", mark);
    return () => {
      regs.delete(r);
      if (active === r) active = null;
      node?.removeEventListener("pointerenter", mark);
      node?.removeEventListener("focusin", mark);
      if (!regs.size) window.removeEventListener("paste", onPaste);
    };
  }, []);
  return el;
}
